import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getAdapter } from 'lib/_common/msdkAdapter';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { config } from 'lib/config';
import storage from 'lib/utils/storage';
import Dialog from '../Dialog';
import { closeModal } from '../Modal';
import { generatorStorageKey } from './helper';
import './index.scss';

const adapter = getAdapter();
export const ReceiveLimitDialog = ({ disableCheck, gameId, isAuto, roleInfo }) => {
  const [isCheck, setIsCheck] = useState(false);

  useEffect(() => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_GUIDE_VIEW);
  }, []);

  useEffect(() => {
    if (disableCheck) return;
    storage.setStorage(
      generatorStorageKey(),
      isCheck,
      dayjs()
        .add(1, 'month')
        .startOf('month'),
    );
  }, [isCheck]);

  const checkConfirm = () => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_GUIDE_DONE);
    setIsCheck(c => !c);
  };

  const reportAndcloseDialog = () => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_GUIDE_CLOSE);
    closeModal();
  };

  const jumpToReceive = () => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_GUIDE_CONFIRM);
    window.location.href = `https://dev.coc.10086.cn/coc3/gr/static-2c/rightsget/#/${gameId}Login?fromPage=%2F${gameId}`;
    closeModal();
  };

  return (
    <Dialog title="增加领奖次数" keyboard={{ onEnter: jumpToReceive, onEscape: reportAndcloseDialog }}>
      <div className="receive-dialog">
        <div className="receive-dialog__content">
          {isAuto ? (
            <div className="content-title">
              已记录您自动下发信息，下发账号为：
              <span>{roleInfo}</span>
              ，请前往运营商页面增加领奖次数
            </div>
          ) : (
            <div className="content-title">
              由于运营商侧的权益领取政策，您在
              <span>领奖前需前往运营商页面发起申请</span>
              ，增加领奖次数，以下为具体步骤：
            </div>
          )}
          <div className="content-step">
            <p>1、点击增加领奖次数按钮</p>
            <p>2、进入页面输入手机号&验证码</p>
            <p>3、点击领取按钮领取权益</p>
            {isAuto ? '（获取领奖次数后才会进行对应的权益下发）' : ''}
          </div>
        </div>
        {disableCheck ? null : (
          <div className="footer-confirm" onClick={checkConfirm}>
            <div className={`footer-confirm__checkbox ${isCheck ? 'checked' : ''}`}></div>
            <div className="footer-confirm__text">已完成发起，本月不再弹出此提醒</div>
          </div>
        )}

        <div className="receive-dialog__footer">
          <div className="footer-btn" onClick={reportAndcloseDialog}>
            我知道了
          </div>
          <div className="footer-btn confirm" onClick={jumpToReceive}>
            增加领奖次数
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export const ReceiveLoadingDialog = ({ mobile, gameId, isAuto, roleInfo }) => {
  useEffect(() => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_LOADING_VIEW);
  }, []);
  const jumpToMiniprogram = () => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.RECEIVE_LOADING_CLICK);
    adapter.openWechatMiniProgram({
      appName: 'benefit',
      path: '/pages/flowReceive/subscribe/index',
      query: `channelCode=${gameId}&mobile=${mobile}`,
      type: config.env,
    });
    closeModal();
  };

  return (
    <Dialog title="领奖次数同步中" keyboard={{ onEnter: jumpToMiniprogram }}>
      <div className="receive-dialog">
        <div className="receive-dialog__content">
          <div className="content-title desc">
            {isAuto ? (
              <>
                已记录下发账号：<span>{roleInfo}</span>。
                由于运营商政策限制，您在领奖前需等待运营商推送领奖次数，目前运营商侧仍未推送相关信息，您可点击前往腾讯福利鹅小程序按钮，授权权益领取通知，
                我们将在资格推送后提醒您领取礼包（开启自动下发后您可接收到对应礼包到账提醒）
              </>
            ) : (
              <>
                <span>请开启抽奖礼包到账提醒。</span>
                PS:由于抽奖礼包的特殊性，抽奖礼包无法为您自动下发，您可点击下方按钮授权小程序提醒功能，我们将在您获取抽奖资格时通知您
              </>
            )}
          </div>
        </div>
        <div className="receive-dialog__footer">
          <div className="footer-btn confirm" onClick={jumpToMiniprogram}>
            前往小程序接收权益领取提醒
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export const showReceiveLimitDialog = (disableCheck = false, gameId, props) => (
  <ReceiveLimitDialog disableCheck={disableCheck} gameId={gameId} {...props} />
);

export const showReceiveLoadingDialog = (mobile, gameId, props) => (
  <ReceiveLoadingDialog mobile={mobile} gameId={gameId} {...props} />
);
